import React from "react"
import { FormattedMessage, injectIntl, defineMessages } from "react-intl"
import { Link } from "react-router-dom"
import ActivityFeedEventSearchResult from "../../../state/search/Dto"
import { Intl } from "../../../state/helpers/IntlProps"
import { ACTIVITY_FEED_EVENT_TYPE } from "../../../state/activity-feed/ActivityFeedEventType"

type Props = {
    intl: Intl,
    activity: ActivityFeedEventSearchResult,
}

const messages = defineMessages({
    [ACTIVITY_FEED_EVENT_TYPE.QUOTE_STATUS_APPROVED]: {
        id: "dashboard.activity-feed.quote-pre-approved",
        defaultMessage: "{customer} approved {identifier} from {seller}",
    },
    [ACTIVITY_FEED_EVENT_TYPE.QUOTE_STATUS_DECLINED]: {
        id: "dashboard.activity-feed.quote-pre-declined",
        defaultMessage: "{customer} declined {identifier} from {seller}",
    },
})


const ActivityFeedEventQuoteStatusUpdatedComponent = (props: Props) => {

    return (
        <div>
            <FormattedMessage
                {...messages[props.activity.getActivityType()]}
                values={{
                    customer: <Link to={"/contacts/" + props.activity.getContactId() + "/details"}>
                        {props.activity.getContactName()}
                    </Link>,
                    seller: props.activity.getCreatedByUserName(),
                    identifier: <Link to={"/" + props.activity.getObjectType() + "/" + props.activity.getObjectId() + "/edit"}>
                        {props.activity.getIdentifier()}
                    </Link>
                }}
            />
        </div>
    )
}

export default injectIntl(ActivityFeedEventQuoteStatusUpdatedComponent)


// WEBPACK FOOTER //
// ./src/dashboard/activity-feed/components/ActivityFeedEventQuoteStatusUpdatedComponent.tsx